module.exports = __webpack_public_path__ + "img/evaluateItemLogo4.011f103c.png";